import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarIcon, WindIcon, MoonIcon, AppleIcon } from 'lucide-react';
export function WhatYouGet() {
  return <section className="w-full bg-[#FBF9F4] py-16 md:py-24" data-id="element-334">
      <div className="max-w-5xl mx-auto px-4" data-id="element-335">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-336">
          <div className="text-center mb-12" data-id="element-337">
            <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl font-bold text-[#2D3436] mb-4" data-id="element-338">
              ¿Qué incluye el Protocolo?
            </h2>
            <p className="text-[#2D3436]/60 max-w-2xl mx-auto" data-id="element-339">
              Todo lo que necesitas para desinflamar tu vientre en una semana
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-340">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-341">
              <div className="flex items-start gap-4" data-id="element-342">
                <div className="flex-shrink-0 w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center" data-id="element-343">
                  <BookOpenIcon className="w-6 h-6 text-[#C4A962]" data-id="element-344" />
                </div>
                <div data-id="element-345">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-346">
                    Guía Digital "Vientre Plano Post-30"
                  </h3>
                  <p className="text-[#2D3436]/70 text-sm" data-id="element-347">
                    El manual paso a paso para entender tu nuevo metabolismo y
                    cómo funciona la inflamación por cortisol.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-348">
              <div className="flex items-start gap-4" data-id="element-349">
                <div className="flex-shrink-0 w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center" data-id="element-350">
                  <CalendarIcon className="w-6 h-6 text-[#C4A962]" data-id="element-351" />
                </div>
                <div data-id="element-352">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-353">
                    Plan de Acción de 7 Días
                  </h3>
                  <p className="text-[#2D3436]/70 text-sm" data-id="element-354">
                    Qué comer y qué evitar para ver resultados visuales en una
                    semana. Sin complicaciones ni recetas elaboradas.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-355">
              <div className="flex items-start gap-4" data-id="element-356">
                <div className="flex-shrink-0 w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center" data-id="element-357">
                  <WindIcon className="w-6 h-6 text-[#C4A962]" data-id="element-358" />
                </div>
                <div data-id="element-359">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-360">
                    Técnica de Respiración Vago-Reset
                  </h3>
                  <p className="text-[#2D3436]/70 text-sm" data-id="element-361">
                    El interruptor de 2 minutos que detiene la hinchazón antes
                    de comer. Simple, rápido y efectivo.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-362">
              <div className="flex items-start gap-4" data-id="element-363">
                <div className="flex-shrink-0 w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center" data-id="element-364">
                  <MoonIcon className="w-6 h-6 text-[#C4A962]" data-id="element-365" />
                </div>
                <div data-id="element-366">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-367">
                    Ritual Nocturno de Drenaje
                  </h3>
                  <p className="text-[#2D3436]/70 text-sm" data-id="element-368">
                    Un masaje linfático de 3 minutos para despertar deshinchada
                    cada mañana.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow md:col-span-2 md:max-w-md md:mx-auto" data-id="element-369">
              <div className="flex items-start gap-4" data-id="element-370">
                <div className="flex-shrink-0 w-12 h-12 bg-[#C4A962]/10 rounded-xl flex items-center justify-center" data-id="element-371">
                  <AppleIcon className="w-6 h-6 text-[#C4A962]" data-id="element-372" />
                </div>
                <div data-id="element-373">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-374">
                    Checklist de Alimentos Escudo
                  </h3>
                  <p className="text-[#2D3436]/70 text-sm" data-id="element-375">
                    Tu lista de supermercado anti-inflamatoria. Llévala contigo
                    y compra con confianza.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}